/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICRTouchConnectionScheduleSitesConfig } from './ICRTouchConnectionScheduleSitesConfig';
import {
    ICRTouchConnectionScheduleSitesConfigFromJSON,
    ICRTouchConnectionScheduleSitesConfigFromJSONTyped,
    ICRTouchConnectionScheduleSitesConfigToJSON,
    ICRTouchConnectionScheduleSitesConfigToJSONTyped,
} from './ICRTouchConnectionScheduleSitesConfig';

/**
 * 
 * @export
 * @interface ShowIcrTouchConnectionScheduleSitesConfigResponse
 */
export interface ShowIcrTouchConnectionScheduleSitesConfigResponse {
    /**
     * 
     * @type {ICRTouchConnectionScheduleSitesConfig}
     * @memberof ShowIcrTouchConnectionScheduleSitesConfigResponse
     */
    data: ICRTouchConnectionScheduleSitesConfig;
}

/**
 * Check if a given object implements the ShowIcrTouchConnectionScheduleSitesConfigResponse interface.
 */
export function instanceOfShowIcrTouchConnectionScheduleSitesConfigResponse(value: object): value is ShowIcrTouchConnectionScheduleSitesConfigResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowIcrTouchConnectionScheduleSitesConfigResponseFromJSON(json: any): ShowIcrTouchConnectionScheduleSitesConfigResponse {
    return ShowIcrTouchConnectionScheduleSitesConfigResponseFromJSONTyped(json, false);
}

export function ShowIcrTouchConnectionScheduleSitesConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowIcrTouchConnectionScheduleSitesConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ICRTouchConnectionScheduleSitesConfigFromJSON(json['data']),
    };
}

  export function ShowIcrTouchConnectionScheduleSitesConfigResponseToJSON(json: any): ShowIcrTouchConnectionScheduleSitesConfigResponse {
      return ShowIcrTouchConnectionScheduleSitesConfigResponseToJSONTyped(json, false);
  }

  export function ShowIcrTouchConnectionScheduleSitesConfigResponseToJSONTyped(value?: ShowIcrTouchConnectionScheduleSitesConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ICRTouchConnectionScheduleSitesConfigToJSON(value['data']),
    };
}

